import Avvvatars from "avvvatars-react";
import { useState } from "react";

export const UserAvatar = ({
  src,
  className,
  alt,
  value,
  size = 32,
}: {
  src?: string | null;
  className?: string;
  alt?: string;
  value?: string;
  size?: number;
}) => {
  const [isImageError, setIsImageError] = useState(false);
  if (src && src !== "" && !isImageError) {
    return (
      <img
        src={src}
        className={`${className ?? ""} object-cover object-center`}
        alt={alt}
        // if the image cannot be loaded, show the avatar with the value
        onError={() => setIsImageError(true)}
      />
    );
  }
  return (
    <div className={`${className ?? ""} overflow-hidden flex-shrink-0`}>
      <Avvvatars
        value={value || alt || "?"}
        style="shape"
        size={size}
        radius={0}
      />
    </div>
  );
};
